import KeenSlider from 'keen-slider';

import BaseModule from '../../../javascripts/helpers/baseModule';

export default class PartnerLogos extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'));

    this.getElements([
      {
        id: 'logos',
        selector: 'logos'
      },
      {
        id: 'prevBtn',
        selector: 'prev-btn'
      },
      {
        id: 'nextBtn',
        selector: 'next-btn'
      }
    ]);

    this.initLogosSlider();
    this.bindEvents();

    this.hasPrev = false;
    this.hasNext = false;
  }

  initLogosSlider() {
    this.logosSlider = new KeenSlider(this.elements.logos, {
      mode: 'free',
      slides: {
        perView: 'auto',
        spacing: 32
      },
      breakpoints: {
        '(min-width: 960px)': {
          slides: {
            perView: 'auto',
            spacing: 60
          }
        }
      },
      detailsChanged: (slider) => {
        const { details } = slider.track;

        const nextHasPrev = details.abs !== details.minIdx;
        const nextHasNext = details.abs !== details.maxIdx;

        if (this.hasPrev !== nextHasPrev) {
          this.elements.self.classList.toggle(
            'partner-logos--has-prev',
            nextHasPrev
          );

          this.hasPrev = nextHasPrev;
        }

        if (this.hasNext !== nextHasNext) {
          this.elements.self.classList.toggle(
            'partner-logos--has-next',
            nextHasNext
          );

          this.hasNext = nextHasNext;
        }
      }
    });
  }

  bindEvents() {
    this.elements.prevBtn.addEventListener('click', () => {
      this.logosSlider.prev();
    });

    this.elements.nextBtn.addEventListener('click', () => {
      this.logosSlider.next();
    });
  }
}
